import { Injectable } from '@angular/core';

import { Actions, State } from '@ngxs/store';

import { ReferralQuestion } from '@recruitee/http/types';

import { HttpApiService } from '../../../core/http-api.service';
import { EntityStateHelpers, EntityUpdateStrategy, IEntityState } from '../../../core/state';
import { EntityState } from '../../../core/state/entity-state';

type RepositoryType = IEntityState<ReferralQuestion>;

@State<RepositoryType>({
  name: 'referral_questions',
  defaults: EntityStateHelpers.createDefaultState(),
})
@Injectable()
export class ReferralsQuestionsRepo extends EntityState<ReferralQuestion>() {
  constructor(private httpApi: HttpApiService, protected actions$: Actions) {
    super(actions$, EntityUpdateStrategy.update);
  }
}
